import { render, staticRenderFns } from "./MainMedia.vue?vue&type=template&id=20208846&scoped=true"
import script from "./MainMedia.vue?vue&type=script&lang=js"
export * from "./MainMedia.vue?vue&type=script&lang=js"
import style0 from "./MainMedia.vue?vue&type=style&index=0&id=20208846&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20208846",
  null
  
)

export default component.exports